import { ApiDurationInfo, ApiDurationType } from '@ibe/api';

class DurationFactory {
  static create(duration: number, type: ApiDurationType = ApiDurationType.NIGHT): ApiDurationInfo {
    return {
      duration,
      type
    };
  }
}

export default DurationFactory;
